import React, { SyntheticEvent } from 'react';
import { Button } from '@asigna/kit';
import cx from 'classnames';

import { AppsMetadata } from '../../appList';
import trashIcon from '../../util/images/trash.svg';
import { EmbeddedBadge } from '../AppCard';

import s from './index.module.scss';

export type CustomAppCardProps = {
  app: AppsMetadata;
  onClick: (event: SyntheticEvent) => void;
  onDelete: (event: SyntheticEvent) => void;
};

export const CustomAppCard: React.FC<CustomAppCardProps> = React.memo((props) => {
  const { app, onClick, onDelete } = props;

  return (
    <div
      className="bg-black-2 p-20 rounded-[12px] w-full flex gap-16 border-[.5px] border-black-4 min-h-[144px]"
      onClick={onClick}
    >
      <div className="w-48 sm:w-64 h-48 sm:h-64 rounded-[32px] border-white-5 flex items-center justify-center bg-white-10 shrink-0">
        <img src={app.favicon} width={56} height={56} className="rounded-[32px]" alt="app icon" />
      </div>
      <div className="flex flex-col items-start flex-1 gap-8 text-left">
        <div className="flex items-center gap-8">
          <p className="text-m16 text-white">{app.title || app.url}</p>
          <EmbeddedBadge />
        </div>
        <p className={cx('text-r14 text-regular', s.treelines)}>{app.description}</p>
      </div>
      {/* TODO Icon Button */}
      <Button
        leftIcon={trashIcon}
        onClick={onDelete}
        colorType="inherit"
        size="sm"
        className="w-32 h-32 border-[.5px] border-black-4 !px-0"
      />
    </div>
  );
});
